import { useEffect, useState } from "react";
import { Card, Table, InputNumber, Tag } from "antd";
import { useSelector } from "react-redux";
import MondayButton from "../../commonComponents/MondayButton/MondayButton";
import dayjsTZ from "../../../utils/dayjs";

// Who has served how often, and the manual correction of that baseline —
// needed for service that predates the imported sheet.
const FairnessPanel = ({ fairness, saving, onAdjustHistory }) => {
  const { isDarkMode } = useSelector((state) => state.usersList);
  const [edits, setEdits] = useState({});

  useEffect(() => {
    setEdits({});
  }, [fairness]);

  const columns = [
    {
      title: "Punonjësi",
      dataIndex: "employeeName",
      render: (name, row) => (
        <span>
          {name}
          {row.active === false ? <Tag color="default">pezulluar</Tag> : null}
        </span>
      ),
    },
    {
      title: "Javë të shërbyera",
      dataIndex: "servedCount",
      width: 170,
      sorter: (a, b) => a.servedCount - b.servedCount,
      render: (value, row) => (
        <InputNumber
          min={0}
          size="small"
          value={edits[row.employeeId] ?? value}
          onChange={(next) =>
            setEdits((prev) => ({ ...prev, [row.employeeId]: next }))
          }
        />
      ),
    },
    {
      title: "Herën e fundit",
      dataIndex: "lastServedWeekStart",
      width: 150,
      render: (value, row) =>
        value ? (
          <span>
            {dayjsTZ(value).format("DD/MM/YYYY")}
            {row.weeksSinceServed !== null ? (
              <span className="aquamanMuted"> ({row.weeksSinceServed} javë)</span>
            ) : null}
          </span>
        ) : (
          <Tag color="green">nuk ka shërbyer</Tag>
        ),
    },
    {
      title: "Radha tjetër",
      dataIndex: "nextWeekStart",
      width: 130,
      render: (value) => (value ? dayjsTZ(value).format("DD/MM/YYYY") : "—"),
    },
  ];

  const dirty = Object.keys(edits).filter((id) => {
    const row = fairness.find((f) => f.employeeId === id);
    return row && edits[id] !== null && edits[id] !== row.servedCount;
  });

  return (
    <Card
      className={`aquamanCard ${isDarkMode ? "dark" : ""}`}
      title="Balanca e rotacionit"
      extra={
        <MondayButton
          disabled={saving || dirty.length === 0}
          onClick={() =>
            onAdjustHistory(
              dirty.map((employeeId) => ({
                employeeId,
                servedCount: edits[employeeId],
              }))
            )
          }
        >
          Ruaj korrigjimet ({dirty.length})
        </MondayButton>
      }
    >
      <Table
        size="small"
        rowKey="employeeId"
        pagination={false}
        dataSource={fairness}
        columns={columns}
        scroll={{ y: 320 }}
      />
    </Card>
  );
};

export default FairnessPanel;
